import { useState } from 'react';
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
    Box, VStack, Text, Button, FormControl, FormLabel, useToast
} from '@chakra-ui/react';
import AsyncSelect from 'react-select/async';
import { authAPI } from '../services/api';

const loadStudents = (input) =>
    authAPI.getStudents({ search: input, limit: 20 })
        .then(res => res.data.map(s => ({
            value: s.id,
            label: `${s.full_name} (${s.class?.name || '未分班'})`
        })));

const LunchBatchModal = ({ isOpen, onClose, selectedDates, onSuccess }) => {
    const toast = useToast();
    const [batchStudent, setBatchStudent] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const handleClose = () => { setBatchStudent(null); onClose(); };

    const handleSubmit = async () => {
        if (!batchStudent || selectedDates.size === 0) return;
        setSubmitting(true);
        try {
            await authAPI.lunch.batchOrder({
                student_id: batchStudent.value,
                dates: Array.from(selectedDates)
            });
            toast({ title: `已為 ${batchStudent.label} 訂 ${selectedDates.size} 天`, status: 'success' });
            setBatchStudent(null);
            onSuccess();
            onClose();
        } catch (e) {
            toast({ title: '訂餐失敗', description: e.response?.data?.detail, status: 'error' });
        } finally { setSubmitting(false); }
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>跨日訂餐</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={4}>
                        <Box w="100%" bg="orange.50" p={3} borderRadius="md" border="1px solid" borderColor="orange.200">
                            <Text fontSize="sm" color="orange.700" fontWeight="bold" mb={1}>
                                已選日期（{selectedDates.size} 天）
                            </Text>
                            <Text fontSize="xs" color="orange.600" lineHeight="tall">
                                {Array.from(selectedDates).sort().join('　')}
                            </Text>
                        </Box>
                        <FormControl isRequired>
                            <FormLabel fontSize="sm">選擇學生</FormLabel>
                            <AsyncSelect
                                loadOptions={loadStudents}
                                value={batchStudent}
                                onChange={setBatchStudent}
                                placeholder="輸入姓名搜尋..."
                                isClearable
                                noOptionsMessage={() => '輸入至少 1 個字開始搜尋'}
                                loadingMessage={() => '搜尋中...'}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </FormControl>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" mr={3} onClick={handleClose}>取消</Button>
                    <Button colorScheme="orange" isLoading={submitting} isDisabled={!batchStudent} onClick={handleSubmit}>
                        確認訂餐
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default LunchBatchModal;
